import React from 'react';

const FileUpload = ({ label, message, accept, register, error, value }) => {
  return (
    <>
      <label className="block mb-2 text-base font-medium text-gray-900 text-left">{label}</label>
      <input
        accept={accept}
        className={`p-2.5 block w-full text-base ${
          value ? 'text-black' : 'text-gray-400'
        } border border-gray-300 file:rounded-lg rounded-lg cursor-pointer focus:outline-none file:bg-gray-100 file:border-none file:px-2 file:text-black`}
        type="file"
        {...register}
      />
      <p className="mt-1 text-sm text-gray-400 text-left">{message}</p>
      {error && <p className="text-red-500 text-left mt-1">{error?.message}</p>}
    </>
  );
};

export default FileUpload;
